import { useState, useRef, useCallback } from "react";
import { NotifyContext } from "../contexts";
import { NotifyPopup } from "../components/notify-popup";

const NotifyProvider = ({ children }) => {
  const [notify, setNotify] = useState(null);
  const timerRef = useRef(null);

  const toggleNotify = useCallback((content = null) => {
    // Cancel any pending auto-dismiss from a previous notification
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    // Replace whatever is showing (or null to clear)
    setNotify(content);
  }, []);

  return (
    <NotifyContext.Provider value={{ notify, toggleNotify, timerRef }}>
      <NotifyPopup />
      {children}
    </NotifyContext.Provider>
  );
};

export default NotifyProvider;
